import React from 'react';
import {
  ATTENDANCE_DAYS_FILTER_CUSTOM,
  ATTENDANCE_DAYS_OPTIONS,
} from '../../utils/attendanceDateRange';

export default function AttendanceDaysFilter({
  mode = 'days',
  days,
  onModeChange,
  onDaysChange,
  id = 'attendance-days',
  compact = false,
}) {
  const labelClass = compact
    ? 'block text-sm font-medium text-gray-700 mb-1'
    : 'block text-sm font-medium text-gray-700 mb-1';
  const selectClass = compact
    ? 'w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-[#674936] bg-white'
    : 'w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-[#674936] bg-white';

  const selectValue =
    mode === ATTENDANCE_DAYS_FILTER_CUSTOM
      ? ATTENDANCE_DAYS_FILTER_CUSTOM
      : String(days);

  const handleChange = (e) => {
    const value = e.target.value;
    if (value === ATTENDANCE_DAYS_FILTER_CUSTOM) {
      onModeChange(ATTENDANCE_DAYS_FILTER_CUSTOM);
      return;
    }
    onModeChange('days');
    onDaysChange(Number(value));
  };

  return (
    <div className="w-full sm:max-w-[10rem]">
      <label htmlFor={id} className={labelClass}>
        Period
      </label>
      <select
        id={id}
        value={selectValue}
        onChange={handleChange}
        className={selectClass}
      >
        {ATTENDANCE_DAYS_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
        <option value={ATTENDANCE_DAYS_FILTER_CUSTOM}>Custom range</option>
      </select>
    </div>
  );
}
